import { translatedOptions } from 'pages/AutomationEngine/dialogs/ActionWizard/subsections/StopExecution';
import DraggableStepCard from '../../DraggableStepCard';

export const content = ({ step }) => step.description;

export const getDescription = ({ step: { details }, t }) => {
  const { action, notify } = details;
  const actionString =
    translatedOptions(t).find(({ value }) => value === action)?.label ||
    t('Unknown');

  return t('{{action}} and {{notify}}', {
    action: actionString,
    notify: notify ? t('Notify') : t('Do Not Notify'),
  });
};

export default function StopExecutionCard({ step, ...others }) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
